<template>
  <router-link :to="'/'+meta.full_slug" class="post-flex flex-col">
    <div class="post-flex-end gap-6">
        <h2 class="font-luckiest text-2xl md:text-4xl text-primary">{{content.title}}</h2>
        <img src="/img/leaf.png" class="w-8 md:w-12" loading="lazy" alt="">
    </div>
    <div class="h-1.5 bg-primary rounded-full w-full mt-2"></div>
    <div class="relative mt-6">
      <img class="aspect-ratio-16-9 object-cover" loading="lazy" :src="content.img" alt="">
      <div class="absolute top-0 left-0 p-3 md:p-6 bg-green-500 flex parallelogram">
        <span class="text-white font-bold z-10 relative">{{[meta.first_published_at, "YYYY-MM-DDTHH:mm:ss.SSSZ"]| moment("Do MMMM YYYY")}}</span>
      </div>
    </div>
    <vue-markdown v-if="content.text" class="post-content mt-6">{{content.text.slice(0, 150) + '...'}}</vue-markdown>
    <div class="post-button md:text-lg mt-6">{{$t('message.more')}}</div>
  </router-link>
</template>

<script>
export default {
  props: {
    content: null,
    meta: null
  },
  data() {
    return {
      link: {
        slug: null
      }
    };
  }
};
</script>

<style lang="scss">
.post-flex {
  @apply flex items-start;
}
.post-flex-end {
  @apply flex items-end;
}
.post-content {
  p + p {
    margin-top: 1rem;
  }
}
.post-button {
  color: rgb(255, 255, 255);
  background-color: rgb(93, 192, 213);
  font-family: "Luckiest Guy", cursive;
  text-decoration: none;
  display: inline-block;
  padding: 15px 25px;
  border-radius: 15px;
  border: none;
  letter-spacing: 1px;
  -webkit-box-shadow: 2px 2px 12px 5px rgba(114, 108, 108, 0.2);
  box-shadow: 2px 2px 12px 5px rgba(114, 108, 108, 0.2);
  -webkit-transition: -webkit-transform 0.4s;
  transition: -webkit-transform 0.4s;
  transition: transform 0.4s;
  transition: transform 0.4s, -webkit-transform 0.4s;
  -webkit-transform: scale(1) translateY(0) translateZ(0);
  transform: scale(1) translateY(0) translateZ(0);
  cursor: pointer;
  transition: transform 0.2s ease-in-out;

  &:hover {
    transition: transform 0.2s ease-in-out;
    transform: scale(1.05) translateY(-10px);
  }
}
</style>
